import { render, staticRenderFns } from "./TablePivotConfig.vue?vue&type=template&id=612f3f5b&scoped=true&"
import script from "./TablePivotConfig.vue?vue&type=script&lang=js&"
export * from "./TablePivotConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f3f5b",
  null
  
)

export default component.exports